import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { BsGithub } from "react-icons/bs";
import { BsTwitter } from "react-icons/bs";
import { FiMail } from "react-icons/fi";
import "./style.css";

export default function Footer() {
  return (
    <div className="footer-el">
      <a
        role="button"
        href="https://www.github.com/MadhaviGupta"
        className="socialIcons"
      >
        <BsGithub />
      </a>
      <a
        role="button"
        href="https://www.linkedin.com/in/madhavi-gupta-6b9358219/"
        className="socialIcons"
      >
        <BsLinkedin />
      </a>
      <a
        role="button"
        href="mailto:madhavigupta1225@gmail.com"
        className="socialIcons"
      >
        <FiMail />
      </a>
      <a
        role="button"
        href="https://twitter.com/Madhaviig1"
        className="socialIcons"
      >
        <BsTwitter />
      </a>
    </div>
  );
}
